import * as React from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate ,useParams } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import toast from 'react-hot-toast';
import { postRequest } from '../../../lib/api';
import { useContext } from 'react';
import { AuthContext } from '../../../authContext/context';
import BreadcrumbsWrapper from '../../../components/breadcrumbs'; 


export default function CreateEditGroup() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm();

  const navigate = useNavigate();
  const {id} = useParams()
  const authCtx = useContext(AuthContext);
  const [loading, setLoading] = React.useState(false);


 React.useEffect(() => {
  const fetchUserGroupData = async () => {
    try {
      const response = await postRequest(`private/singleUserGroup/${id}`, {});
      if (response?.status === 200) {
        const data = response?.data;

        reset({
          title: data?.title || '',
          is_default: !!data?.is_default
        });
      } else {
       // toast.error(response?.message || 'Failed to load solicitor data');
      }
    } catch (err) {
      toast.error(err?.message || 'Error loading solicitor');
    }
  };

  fetchUserGroupData();
}, [id, authCtx.token, reset]);

  const onSubmit = async (data) => {
    setLoading(true);
    try {

      const payload = {
        title: data?.title,
        is_default: !!data?.is_default
      };

      const response = await postRequest(`private/editUserGroup/${id}`, payload);
       console.log(response  ,'sadsads')
      if (response?.status == 200) {
        toast.success('Usergroup updated successfully!');
       //dispatch(updateSolicitor(response?.data));

        reset();
        navigate(-1);
      } else {
        toast.error(response?.message || 'UserGroup update failed');
      }
    } catch (err) {
      toast.error(err?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
        <BreadcrumbsWrapper
                          items={[
                            { label: 'Dashboard', path: '/dashboard' },
                            { label: 'User Groups', path: '/user-groups' },
                            { label: 'Edit User Group', path: '' },
                          ]}
                        />
                  <br></br>
      <div className="page-header">
        <h1 className="mt-0">Edit User Group</h1>
      </div>

      <div className="page-top-formview mb-3">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="mb-3">
            <Form.Group as={Col} controlId="title">
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text"
                placeholder="Title of user group"
                {...register('title', { required: 'Title is required' })}
                isInvalid={!!errors.title}
              />
              <Form.Control.Feedback type="invalid">
                {errors.title?.message}
              </Form.Control.Feedback>
            </Form.Group>
            
          </Row>
           <Form.Group as={Col} controlId="is_default">
              <Form.Check
                type="checkbox"
                label="Is Default"
                {...register('is_default')}
              />
            </Form.Group>

          <Stack direction="row" spacing={2}>
            <Button variant="outlined" color="inherit" type="button" onClick={() => navigate(-1)}>
              Cancel
            </Button>
            <Button variant="contained" className='red-bg red-button text-capitalize' type="submit" disabled={loading}>
              {loading ? <CircularProgress size={20} color="inherit" /> : 'Submit'}
            </Button>
          </Stack>
        </Form>
      </div>
    </>
  );
}